import { SizeRecommendationModel } from '../utils/types';

// 이전 상품 세션 스토리지 정리
export const clearOldSessionStorage = (currentProductId: string) => {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  Object.keys(sessionStorage).forEach((key) => {
    if (
      !key.includes(currentProductId) &&
      (key.includes('size_recommend_login') || key.includes('size_recommend_body_info'))
    ) {
      sessionStorage.removeItem(key);
    }
  });
};

// 로그 전송 및 관련 세션 처리
export const handleImpressionLog = ({
  catalogProductId,
  sizeRecommendation,
  sizeRecommendationImpression,
}: {
  catalogProductId: string;
  sizeRecommendation: SizeRecommendationModel;
  sizeRecommendationImpression: (params: any) => void;
}) => {
  if (typeof sessionStorage === 'undefined') {
    return;
  }

  const isLoggedinSession = sessionStorage.getItem(`size_recommend_login?${catalogProductId}`);
  const { recommendationType, recommendOptionValueList, userAccount } = sizeRecommendation;

  // 로그인 상태인데 유저 신체 정보가 없으면 로그 전송하지 않고 세션만 정리
  if (isLoggedinSession && !userAccount?.body) {
    sessionStorage.removeItem(`size_recommend_login?${catalogProductId}`);
    return;
  }

  // 로그 전송
  sizeRecommendationImpression({
    catalogProductId,
    recommendationType,
    recommendOptionValueList: recommendOptionValueList.map(({ ranking, name }) => ({ ranking, name })),
  });

  // 로그 전송 후 세션 정리
  sessionStorage.removeItem(`size_recommend_login?${catalogProductId}`);
};
